import React, { useState, useEffect } from "react";

import "react-toastify/dist/ReactToastify.css";
import { QueryClient, QueryClientProvider } from "react-query";

import { ptBR } from "@material-ui/core/locale";
import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { useMediaQuery } from "@material-ui/core";
import ColorModeContext from "./layout/themeContext";

import Routes from "./routes";

const queryClient = new QueryClient();

const App = () => {
    const [locale, setLocale] = useState();

    const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
    const preferredTheme = window.localStorage.getItem("preferredTheme");
    const [mode, setMode] = useState(preferredTheme ? preferredTheme : prefersDarkMode ? "dark" : "light");

    const colorMode = React.useMemo(
        () => ({
            toggleColorMode: () => {
                setMode((prevMode) => (prevMode === "light" ? "dark" : "light"));
            },
        }),
        []
    );

    const theme = createTheme(
        {
            scrollbarStyles: {
                "&::-webkit-scrollbar": {
                    width: '8px',
                    height: '8px',
                },
                "&::-webkit-scrollbar-thumb": {
                    boxShadow: 'inset 0 0 6px rgba(0, 0, 0, 0.3)',
                    backgroundColor: "#e8e8e8",
                },
            },
            scrollbarStylesSoft: {
                "&::-webkit-scrollbar": {
                    width: "8px",
                },
                "&::-webkit-scrollbar-thumb": {
                    backgroundColor: mode === "light" ? "#FFFFFF" : "#0F1B20",
                },
            },
            typography: {
                fontFamily: '"Poppins", "Helvetica", "Arial", sans-serif',
            },
            palette: {
                type: mode,
                primary: { main: "#264e96" },
                secondary: { main: "#1c9c5c" },
                textPrimary: mode === "light" ? "#172c54" : "#FFFFFF",
                background: {
                    default: mode === "light" ? "#FFFFFF" : "#172c54",
                    paper: mode === "light" ? "#FFFFFF" : "#264e96",
                },
                borderPrimary: mode === "light" ? "#264e96" : "#FFFFFF",
                dark: { main: mode === "light" ? "#172c54" : "#FFFFFF" },
                light: { main: mode === "light" ? "#FFFFFF" : "#264e96" },
                tabHeaderBackground: mode === "light" ? "#FFFFFF" : "#264e96", //Menu Atendimentos (Abertas, Grupos...)
                optionsBackground: mode === "light" ? "#F4F7FB" : "#172c54", //Aba Atendimentos (Novos, Todos, Filas)
                options: mode === "light" ? "#FFFFFF" : "#264e96", //Configurações (Abas: Integrações IXC ASAAS...)
                fontecor: "#FFFFFF",
                fancyBackground: mode === "light" ? "#F4F7FB" : "#172c54", //Cor Fundo Principal Escura
                bordabox: mode === "light" ? "#F4F7FB" : "#172c54", //Borda acima de onde digita a mensagem
                newmessagebox: mode === "light" ? "#F4F7FB" : "#172c54", //Em torno da Caixa de onde digita a mensagem
                inputdigita: mode === "light" ? "#FFFFFF" : "#264e96", //Caixa de Texto Atendimento onde digita a mensagem
                contactdrawer: mode === "light" ? "#FFFFFF" : "#264e96", // ONDE???????????
                announcements: mode === "light" ? "#FFFFFF" : "#264e96", // ONDE???????????
                login: mode === "light" ? "#FFFFFF" : "#172c54",
                announcementspopover: mode === "light" ? "#FFFFFF" : "#264e96", // ONDE???????????
                chatlist: "#264e96",
                boxlist: mode === "light" ? "#E9EEF8" : "#6c85c3",
                boxchatlist: mode === "light" ? "#ededed" : "#264e96", // ONDE???????????
                total: mode === "light" ? "#fff" : "#172c54",
                messageIcons: mode === "light" ? "#264e96" : "#F3F3F3",
                inputBackground: mode === "light" ? "#FFFFFF" : "#264e96", // ONDE???????????
                barraSuperior: "#264e96", //Barra Horizontal
                boxticket: mode === "light" ? "#FFFFFF" : "#264e96", //Cor de fundo da imagem quando os tickets não estão selecionados
                listaInterno: mode === "light" ? "#E9EEF8" : "#6c85c3",
                campaigntab: mode === "light" ? "#FFFFFF" : "#264e96",
                fundoBackground: mode === "light" ? "#FFFFFF" : "#264e96", //Cor Fundo Interna Mediana
                corIconespaginas: "#1c9c5c",
                corIconesbarra: "#e1e4ea",
                corTextobarra: "#FFFFFF",
                corTextosuporte: mode === "light" ? "#172c54" : "#FFFFFF",
                fundologoLateral: "#264e96", //Fundo Logo Superior
                barraLateral: "#264e96", //Barra Vertical
            },
            mode,
        },
        locale
    );

    useEffect(() => {
        const i18nlocale = localStorage.getItem("i18nextLng");
        const browserLocale =
            i18nlocale.substring(0, 2) + i18nlocale.substring(3, 5);

        if (browserLocale === "ptBR") {
            setLocale(ptBR);
        }
    }, []);

    useEffect(() => {
        window.localStorage.setItem("preferredTheme", mode);
    }, [mode]);


    return (
        <ColorModeContext.Provider value={{ colorMode }}>
            <ThemeProvider theme={theme}>
                <QueryClientProvider client={queryClient}>
                    <Routes />
                </QueryClientProvider>
            </ThemeProvider>
        </ColorModeContext.Provider>
    );
};

export default App;
